export default class SearchController {
  /* @ngInject */
  constructor(ConfigurationService, $anchorScroll, DataService) {
    this.authorable = ConfigurationService.getConfiguration();
    this.$anchorScroll = $anchorScroll;
    this.form_data = DataService.getData();

    this.$anchorScroll();
  }
}



// WEBPACK FOOTER //
// ./src/containers/search/search.controller.js